<template>
    <section v-if="loaded">
        <v-container class="nav">
            <v-btn icon class="black--text" @click="$router.go(-1)">
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon class="white--text">
                                {{ mdiPaperclip }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Annual Check Up Request Revalidation
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <v-container :style="`padding: ${screen_width > 959 ? '' : screen_width > 599 ? '0 30px' : '0'};`">
            <MainPage
                v-if="isRevalidationResultEmpty"
                :is-oppan-available="isOppanAvailable"
                :approval_no="approval_no"
                :submit_enabled="submit_enabled"
                @generateResult="generateResult"
            />
            <APERevalidateResult
                v-else-if="!errMsg"
                :data="resultData"
            />
            <div v-else>
                <div :style="`padding: ${screen_width > 599 ? '' : '0 18px' }`">
                    <h1>Unable to Proceed with Annual Check-Up Revalidation</h1>
                    <p style="margin-top: 30px;">
                        Your Annual Check-Up cannot be revalidated at this time. Here's why:
                    </p>
                </div>
                <v-alert
                    type="error"
                    text
                    color="error darken-3"
                    :icon="mdiAlertCircleCheckOutline"
                >
                    <strong>{{ errMsg }} </strong>
                </v-alert>
                <v-alert
                    text
                    color="black"
                >
                    <p><strong>Disclaimer: </strong></p>
                    The approval for the referenced service or treatment is provisional. If, upon further review, it is determined that the service or treatment is not eligible for coverage under your health card plan, you may be billed back for any or all costs incurred.
                </v-alert>
                <v-divider />
                <div :style="`padding: ${screen_width > 599 ? '' : '0 18px' }`">
                    <p style="margin-top: 10px;">
                        <strong>For further inquiries:</strong>
                    </p>
                    <p>Please contact HMI directly at <span style="color: #009688; font-weight: 600;">(02) 8811-1313, (02) 7752-0552 and (02) 8865-3700, 0999-993-4895 and 0917-853-3705.</span>.</p>
                </div>
            </div>
        </v-container>
    </section>
</template>

<script>
import { mdiAlertCircleCheckOutline, mdiArrowLeft, mdiPaperclip } from '@mdi/js'
import APERevalidateResult from './APERevalidateResult.vue'
import MainPage from './MainPage.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    components: {
        MainPage,
        APERevalidateResult
    },
    data: () => {
        return({
            mdiAlertCircleCheckOutline, 
            mdiArrowLeft, 
            mdiPaperclip,
            errMsg: null,
            resultData: null,
            isRevalidationResultEmpty: true,
            valid: true,
            validTerms: false,
            facility: '',
            text_reason: '',
            sample_oppan: 123456,
            submit_enabled: true,
            region: '',
            province: '',
            city: '',

            facilityCode: null,
            hospClinDoctorCode: null,

            approval_no: null,

            loaded: false,
            screen_width: document.documentElement.clientWidth + 9
        })
    },
    computed: {
        ...mapGetters(['getUserConsultInfo', 'getACURecentOPPAN', 'revalidateApprovalFuncData']),
        isOppanAvailable: {
            get() {
                this.setApprovalNum()
                return (this.approval_no !== null)
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    async created() {
        this.getACURecentApproval({ MEMBN: this.$cookies.get('usermembn') })
        this.loaded = true
    },
    methods: {
        ...mapActions(['getCsrfToken', 'revalidateApproval', 'getACURecentApproval', 'revalidateApprovalFunc']),
        setApprovalNum() {
            this.approval_no = this.getACURecentOPPAN
        },
        generateResult(data) {
            if (data.status === 403) {
                this.errMsg = data.data.ERROR
            } else {
                this.resultData = data.data
            }
            this.isRevalidationResultEmpty = false
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        }
    }
}
</script>

<style scoped>
section {
    width: 100%;
    background-image: url("~@/assets/dashboardBG.webp");
    background-position: center;
    background-size: cover;
}

h1 {
    font-size: 18px;
}
@media (max-width: 390px) {
    .page-icon {
        display: none;
    }
}

@media (max-width: 599px) {
    /* Navbar */
    .nav {
        margin-top: 60px;
    }
    .nav h2 {
        font-size: 25px;
    }
}
@media (min-width: 599px) and (max-width: 968px) {
    /* Navbar */
    .nav {
        margin-top: 60px;
    }
    .nav h2 {
        font-size: 25px;
    }
}

@media (min-width: 968px) and (max-width: 1264px) {
    /* Navbar */
    .nav {
        margin-top: 60px;
    }
    .nav h2 {
        font-size: 25px;
    }
}
</style>
